module.exports = __webpack_public_path__ + "img/icon-king.0eeaf6b2.png";